import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'andor-section-intro',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './section-intro.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './section-intro.scss',
})
export class SectionIntro {}
